import { createRouter, createWebHistory } from 'vue-router';
import * as crypto from 'crypto-js';
import Structure from '../views/HomeView.vue';
import Contracts from '../views/ContractsView.vue';
import Contacts from '../views/ContactsView.vue';
import Orgs from '../views/OrgsView.vue';
import OrgRequestsView from '../views/OrgRequestsView.vue';
import PrivilegesView from '../views/PrivilegesView.vue';
import PageNotFound from '../views/PageNotFound.vue';
import store from '../store/index';
import { getCookie, setCookie } from '../helpers/cookies';

const base = process.env.VUE_APP_BASE_URL;

const routes = [
  {
    path: '/',
    name: 'Contracts',
    component: Contracts,
  },
  {
    path: '/structure',
    name: 'Structure',
    component: Structure,
    props: true,
    beforeEnter(to, from, next) {
      // загрузка уже идёт (например, запущена перед переходом) — не перебиваем её
      if (!store.state.employeesData.lastPatientsLoading
        && !store.state.employeesData.allPatients.length
        && !store.state.employeesData.employees.length
        && !store.state.employeesData.questioned.length) {
        store.dispatch('employeesData/getLastPatients', { includeServices: false });
      }
      next();
    },
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: Contacts,
  },
  // {
  //   path: '/requests',
  //   name: 'Requests',
  //   component: OrgRequestsView,
  // },
  // {
  //   path: '/redirect-login',
  //   async beforeEnter(to, from, next) {
  //     const now = new Date();
  //     const dateStr = (`0${now.getDate()}`).slice(-2) + (`0${now.getMonth() + 1}`).slice(-2) + now.getFullYear();
  //     const hash = crypto.SHA1(`dev.medsafe.pro${dateStr}`);
  //     const digestHex = hash.toString(crypto.enc.Hex);
  //     window.open(
  //       `https://esia.medsafe.tech/${digestHex}`,
  //       '_self',
  //     );
  //     setCookie('dev-medsafe-pro', digestHex, { secure: true, expires: 1 });
  //   },
  // },
  {
    path: '/requests',
    name: 'Requests',
    component: OrgRequestsView,
    meta: { requiresAuth: true },
  },
  {
    path: '/privileges',
    name: 'Privileges',
    component: PrivilegesView,
    meta: { requiresAuth: true },
  },
  {
    path: '/redirect-login',
    async beforeEnter(to, from, next) {
      const now = new Date();
      const dateStr = (`0${now.getDate()}`).slice(-2) + (`0${now.getMonth() + 1}`).slice(-2) + now.getFullYear();
      const hash = crypto.SHA1(`dev.medsafe.pro${dateStr}`);
      const digestHex = hash.toString(crypto.enc.Hex);
      window.open(
        `https://esia.medsafe.tech/${digestHex}`,
        '_self',
      );
      setCookie('dev-medsafe-pro', digestHex, { secure: true, expires: 1 });
    },
  },
  {
    path: '/orgs',
    name: 'Orgs',
    component: Orgs,
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: PageNotFound,
    async beforeEnter(to, from, next) {
      const url = window.location;
      await store.dispatch('user/createImei');
      const { IMEI } = store.state.user;
      if (!from.name) {
        const regex = /\?code=(.*)/gm;
        const guCode = url.href.match(regex);
        if (guCode && guCode.length && !store.state.user.isAuth) {
          try {
            const res = await fetch(`https://esia.medsafe.tech/r/${getCookie('dev-medsafe-pro')}/${IMEI}${guCode[0]}`);
            if (res.status >= 200 && res.status < 300) {
              const data = await res.json();
              if (data && data.length) {
                if (data[0].TK) {
                  setCookie('id_login', `${data[0].id_login}`, { secure: true, expires: 1 });
                  setCookie('TK', data[0].TK, { secure: true, expires: 1 });
                  const constantParams = {
                    IMEI,
                    Name_app: 'WEB_managers',
                    TK: data[0].TK,
                    id_login: data[0].id_login,
                  };
                  store.commit('user/SET_CONSTANT_PARAMS', constantParams);
                  store.state.user.isAuth = true;
                  next({ path: '/orgs' });
                }
              } else {
                alert('Извините, мы Вас не узнали...');
              }
            }
          } catch (err) {
            console.error(err);
          }
        }
      }
      next({ path: '/orgs' });
    },
  },
];

const router = createRouter({
  history: createWebHistory(base),
  routes,
});

export default router;
